// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs_wrapper__AsC2z","wrapper__route":"breadcrumbs_wrapper__route__1MSk8"};